package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_price

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.SpecialPriceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.GetSpecialPriceRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class GetSpecialPriceRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
):GetSpecialPriceRepository
{
    override suspend fun getSpecialPrice(id: String): SpecialPriceModel {

        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
            query getSpecialPrice(${'$'}id: ID!) {
              cashAssist {
                getSpecialPrice(id:${'$'}id) {
                  ${ApiUtils.Field.id}
                  ${ApiUtils.Field.mod_ver}
                  ${ApiUtils.Field.type}
                  ${ApiUtils.Field.weekDays}
                  dateInterval {
                    ${ApiUtils.Field.from}
                    ${ApiUtils.Field.to}
                    ${ApiUtils.Field.__typename}
                  }
                  timeInterval {
                    ${ApiUtils.Field.from}
                    ${ApiUtils.Field.to}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.price}
                  ${ApiUtils.Field.priceInCafe}
                  tradePrice {
                    ${ApiUtils.Field.count}
                    ${ApiUtils.Field.price}
                    ${ApiUtils.Field.__typename}
                  }
                  actionAmount {
                    ${ApiUtils.Field.more}
                    ${ApiUtils.Field.less}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.actionDiscount}
                  ${ApiUtils.Field.actionGroup}
                  ${ApiUtils.Field.fullDiscount}
                  ${ApiUtils.Field.codeMWSt}
                  ${ApiUtils.Field.codeMWSt2}
                  ${ApiUtils.Field.mode}
                  ${ApiUtils.Field.cashRegisterId}
                  ${ApiUtils.Field.name}
                  ${ApiUtils.Field.__typename}
                }
                ${ApiUtils.Field.__typename}
              }
            }

            """.trimIndent())

            put("variables", buildJsonObject {
                put("id", id)
            })
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }

}